import {SymbolSettingsApiDto} from "./restModels";

export class SymbolSettings {
	constructor(public readonly symbolPackName: string,) {}

	public static fromJson(json: SymbolSettingsApiDto): SymbolSettings {
		return new SymbolSettings(json.symbolPackName)
	}
}